export const DOCUMENT_TYPES = ['W-2', '1099-NEC', '1099-MISC', '1099-INT', '1099-DIV', '1099-R', '1099-G', '1099-K', 'SSA-1099', '1098', '1098-T', '1095-A', 'K-1', 'Bank Statement', 'Credit Card Statement', 'Receipt', 'Invoice', 'Payroll Record', 'Prior Year Return', 'Completed Return', 'Form 8879', 'Other']

export const AI_IMAGE_TYPES = ['image/jpeg', 'image/png', 'image/webp']
export const AI_IMAGE_LIMIT = 3 * 1024 * 1024
export const DOCUMENT_FILE_LIMIT = 20 * 1024 * 1024
const FILE_TYPES = {
  pdf: 'application/pdf', xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', xls: 'application/vnd.ms-excel', csv: 'text/csv',
  doc: 'application/msword', docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  jpg: 'image/jpeg', jpeg: 'image/jpeg', png: 'image/png', webp: 'image/webp',
}

export function documentFileType(file) { return file.type || FILE_TYPES[file.name.split('.').pop().toLowerCase()] || '' }

export function documentFileError(file) {
  if (!file.size) return 'This file is empty. Choose a file with content.'
  if (file.size > DOCUMENT_FILE_LIMIT) return 'This file exceeds the 20 MB limit. Choose a smaller file.'
  const extension = file.name.split('.').pop().toLowerCase()
  if (!FILE_TYPES[extension] || !Object.values(FILE_TYPES).includes(documentFileType(file))) return 'Choose a PDF, Excel, CSV, Word, JPEG, PNG or WebP file.'
  return ''
}

export function canSuggestDocumentType(file) {
  return AI_IMAGE_TYPES.includes(file.type) && file.size > 0 && file.size <= AI_IMAGE_LIMIT
}

export function readImageBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => resolve(String(reader.result).split(',')[1])
    reader.onerror = () => reject(new Error('This photo could not be read. Choose its type manually.'))
    reader.onabort = () => reject(new Error('Photo reading was cancelled.'))
    reader.readAsDataURL(file)
  })
}
